import { render, staticRenderFns } from "./helpcenter.vue?vue&type=template&id=b6b52754"
import script from "./helpcenter.vue?vue&type=script&lang=js"
export * from "./helpcenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports